export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";